import dayjs from 'dayjs';
import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useTableContext } from '../../contexts/TableContext';

//Servicios
import { LogService } from '../../services/api';

//Componentes
import Spinner from '../spinner/Spinner';
import UserLogs from './SettingsLogs';

function UserLogsContainer({}) {
    const { token, masters } = useGlobalContext();
    const { state } = useTableContext();
    const tablePage = useMemo(
        () => state.SettingsLogsPage,
        [state.SettingsLogsPage]
    );

    const [loader, setLoader] = useState(false);
    const [tablePages, setTablePages] = useState();

    const Params = useParams();

    useEffect(() => {
        const getSettingsLogsCuantity = async () => {
            try {
                setLoader(true);

                const settingsLogsCuantity = await LogService.totalRecords({
                    token,
                    objeto: 0,
                    objeto_id: 0,
                });

                if (settingsLogsCuantity)
                    setTablePages(settingsLogsCuantity.data);

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        const getSettingsLogs = async () => {
            try {
                setLoader(true);

                const settingsLogs = await LogService.byObject({
                    token,
                    objeto: 12,
                    objeto_id: 0,
                    pagina: tablePage,
                    cantidad: tableData.pagination,
                });

                if (settingsLogs) {
                    setTableData(buildTableData(settingsLogs.data));
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        getSettingsLogsCuantity();
        getSettingsLogs();
    }, [tablePage]);

    const buildTableData = (data) => {
        return {
            headers: ['Fecha', 'Hora', 'Responsable', 'Nivel', 'Acción'],
            tablePages,
            pagination: 10,
            pageType: 'SettingsLogsPage',
            data:
                data?.length > 0
                    ? data?.map((log) => {
                          return {
                              fecha: dayjs(log.fecha).format('DD-MM-YYYY'),
                              hora: dayjs(log.fecha).format('HH:mm:ss'),
                              responsable: `${log.apellido}, ${log.nombre}`,
                              nivel: masters.UserTypes?.find(
                                  (m) => m.id === log.tipo
                              )?.nombre,
                              accion: masters.AccionTypes?.find(
                                  (at) => at.id === log.accion
                              ).nombre.replace(/_/g, ' '),
                          };
                      })
                    : [],
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    return loader ? <Spinner /> : <UserLogs tableData={tableData} />;
}

export default UserLogsContainer;
